import React from 'react';
import { uniq, get } from 'lodash';
import moment from 'moment';
import { CM_BASE_ROUTE } from '../../constants/cmConstants';
import { message, notification } from 'antd';
import {
  CloseOutlined,
  LoadingOutlined,
  CheckCircleTwoTone,
  CloseCircleOutlined
} from '@ant-design/icons';

// Goes back in browser history. If no history then goes to default path.
export const goBackOr = ({ history, defaultPath = '' }) => {
  if (history?.length <= 2) {
    return history.push(`${CM_BASE_ROUTE}${defaultPath}`);
  }
  history.goBack();
};

export const fromDaysToRangeBack = (numberOfDays) => {
  const now = moment();
  const fromMoment = now.clone().subtract(numberOfDays - 1, 'days');

  return {
    from: fromMoment.startOf('day').valueOf(),
    to: now.endOf('day').valueOf()
  };
};

export const fromDaysToRangeForward = (numberOfDays) => {
  const now = moment();
  const toMoment = now.clone().add(numberOfDays - 1, 'days');

  return {
    from: now.startOf('day').valueOf(),
    to: toMoment.endOf('day').valueOf()
  };
};

export const formatCheckerStatus = (statusCode) =>
  ({
    CHECK_NEEDED: '-',
    APPROVED: 'Approved',
    REJECTED: 'Rejected'
  }[statusCode]);

export const getUniqArrayBy = (list, getBy) =>
  uniq(list.map((item) => get(item, getBy)));

export const downloadFile = (fileData, fileName) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(fileData);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();

  //Clean up link.
  link.parentNode.removeChild(link);
};

export const formatPageItemsRange = ({
  total,
  fromCount,
  toCount,
  itemsLabel = 'Record'
}) => {
  const toCountLabel = total > 1 ? ` - ${toCount}` : '';

  return `Showing ${fromCount}${toCountLabel} of ${total} ${itemsLabel}${
    total > 1 ? 's' : ''
  }`;
};

export const showNotification = ({
  msgKey,
  type,
  content,
  duration,
  close
}) => {
  let msg = close ? (
    <>
      <span dangerouslySetInnerHTML={{ __html: content }} />
      <CloseOutlined
        style={{ color: '#DF6057', margin: 0, top: '-1px' }}
        onClick={() => destoryNotification(msgKey)}
      />
    </>
  ) : (
    content
  );
  const config = {
    key: msgKey,
    type: type,
    content: msg,
    duration: duration
  };
  message.open(config);
};

const destoryNotification = (msgKey) => {
  message.destroy(msgKey);
};

export const showFileDownloadingNotification = ({ key, fileName }) => {
  notification.open({
    key,
    description: `Downloading ${fileName}`,
    duration: 0,
    icon: <LoadingOutlined style={{ color: '#1890FF' }} />
  });
};

export const showFileDownloadSucessNotification = ({ key, fileName }) => {
  notification.open({
    key,
    description: `${fileName} download completed`,
    icon: <CheckCircleTwoTone twoToneColor="#52c41a" />
  });
};

export const showFileDownloadFailedNotification = ({ key, fileName }) => {
  notification.open({
    key,
    description: `Failed to download ${fileName}`,
    icon: <CloseCircleOutlined style={{ color: '#eb2f96' }} />
  });
};

export const getFileNameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null;

  const match = contentDisposition.match(/filename="?([^"]+)"?/);

  return match ? match[1] : null;
};

export const validateNumberInput = (e) => {
  const pattern = new RegExp(/^\d+$/);
  return pattern.test(e.key) || e.key === '' ? e : e.preventDefault();
};

export const getInvalidCustomerIdChars = (value) => {
  return value.match(/[^a-zA-Z0-9!@#$%&*()\-_:|.,;/\\]+/g);
};

export const validateCustomerIdInput = (value) => {
  return !value.match(/[^a-zA-Z0-9!@#$%&*()\-_:|.;/\\]+/g);
};
